import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  configureRateModeThunk,
  setMainBranchThunk,
  syncRatesFromMainThunk,
  copyRatesThunk
} from '../../../store/thunks/rateThunks';
import BranchHierarchyTree from '../../../components/Rates/BranchHierarchyTree';
import RateModeSelector from '../../../components/Rates/RateModeSelector';
import InheritanceSettings from '../../../components/Rates/InheritanceSettings';

const BranchRateConfig = () => {
  const dispatch = useDispatch();
  const { branches } = useSelector(state => state.branch || { branches: [] });
  const { branchConfig, loading } = useSelector(state => state.rate);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const handleModeChange = async (branchCode, mode, settings) => {
    await dispatch(configureRateModeThunk({
      branchCode,
      modeData: {
        mode,
        autoSync: settings.autoSync,
        syncFrequency: settings.syncFrequency
      }
    }));
  };

  const handleSetMainBranch = async (branchCode) => {
    await dispatch(setMainBranchThunk(branchCode));
  };

  const handleSyncFromMain = async (branchCode) => {
    await dispatch(syncRatesFromMainThunk(branchCode));
  };

  const handleCopyRates = async (source, destination) => {
    await dispatch(copyRatesThunk({
      source: { branchCode: source },
      destination: { branchCode: destination }
    }));
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-1">
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="text-lg font-semibold mb-4">Branch Hierarchy</h3>
          <BranchHierarchyTree
            branches={branches}
            mainBranch={branchConfig.mainBranch}
            onSelectBranch={setSelectedBranch}
            onSetMain={handleSetMainBranch}
          />
        </div>
      </div>

      <div className="lg:col-span-2">
        {selectedBranch ? (
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-xl font-semibold mb-4">
              Configure: {selectedBranch.name}
            </h3>

            <div className="mb-6">
              <RateModeSelector
                currentMode={branchConfig.branchModes[selectedBranch.code]}
                onChange={(mode, settings) => 
                  handleModeChange(selectedBranch.code, mode, settings)
                }
              />
            </div>

            <div className="mb-6">
              <InheritanceSettings
                branchCode={selectedBranch.code}
                isMainBranch={selectedBranch.code === branchConfig.mainBranch}
                inheritanceSettings={branchConfig.inheritanceSettings[selectedBranch.code]}
              />
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => handleSyncFromMain(selectedBranch.code)}
                disabled={selectedBranch.code === branchConfig.mainBranch}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
              >
                Sync from Main
              </button>
              <button
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Copy Rates
              </button>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow p-6 text-center text-gray-500">
            Select a branch to configure
          </div>
        )}
      </div>
    </div>
  );
};

export default BranchRateConfig;